<h1 class="settings">Settings</h1>
<app-theme-bar-settings></app-theme-bar-settings>

<h1 class="header">Appearance</h1>

<div
  class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[-5px]"
>
  <!-- Default Themes -->
  <h1 class="sub-header">Default Themes</h1>
  <p class="instructions">Select your default theme</p>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 container">
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
          fill="#21252A"
        >
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
          />
        </svg>
      </div>
      <div class="selector-text">Dark Theme</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
          fill="#2368A2"
        >
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
          />
        </svg>
      </div>
      <div class="selector-text">Default Theme</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
          fill="#F1F3F5"
        >
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
          />
        </svg>
      </div>
      <div class="selector-text">Light Theme</div>
    </div>
  </div>

  <!-- Library Themes -->
  <h1 class="sub-header !mt-[33px]">Library Themes</h1>
  <p class="instructions">Choose a theme from our theme library</p>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 container">
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient id="gradientId" x1="70%" y1="0%" x2="30%" y2="100%">
              <stop offset="30.19%" stop-color="#634000" />
              <stop offset="86.72%" stop-color="#D6B472" />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId)"
          />
        </svg>
      </div>
      <div class="selector-text">Breakfast Tea</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient
              id="gradientId2"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="5.12%" stop-color="#63A2D8 " />
              <stop offset="96.09%" stop-color="#345672 " />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId2)"
          />
        </svg>
      </div>
      <div class="selector-text">Stormy Morning</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient
              id="gradientId3"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#868E96 " />
              <stop offset="100%" stop-color="#2B2D30 " />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId3)"
          />
        </svg>
      </div>
      <div class="selector-text">Quite Clear</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient
              id="gradientId4"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="7.79%" stop-color="#073119 " />
              <stop offset="92.21%" stop-color="#2EDD79 " />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId4)"
          />
        </svg>
      </div>
      <div class="selector-text">Lush Forest</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient
              id="gradientId5"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="4.36%" stop-color="#B82020 " />
              <stop offset="93.85%" stop-color="#520E0E " />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId5)"
          />
        </svg>
      </div>
      <div class="selector-text">Chill Spice</div>
    </div>
    <div class="flex p-6 rounded selector-section">
      <div class="selector-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="56"
          viewBox="0 0 55 56"
        >
          <defs>
            <linearGradient
              id="gradientId6"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#43D5EF " />
              <stop offset="100%" stop-color="#5F2C78 " />
            </linearGradient>
          </defs>
          <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
          <path
            d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
            stroke="#3183C8"
            stroke-opacity="0.7"
            fill="url(#gradientId6)"
          />
        </svg>
      </div>
      <div class="selector-text">Lavender Lullaby</div>
    </div>
  </div>
</div>

<!-- Custom Theme -->

<!-- Brand & Font Color -->
<div class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[5px]">
  <h1 class="sub-header">Custom Theme</h1>
  <p class="instructions">Create Your Custom Theme</p>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 container">
    <div class="rounded">
      <h1 class="sub-header">Brand Color</h1>
      <p class="instructions">Select or Customize your brand color</p>

      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
        <!-- <input
          placeholder="#1A4971"
          class="sub-header !w-[135px] !h-[44px] border text-center ml-[18px]"
          value="#1A4971"
        /> -->
       
        <app-colorpicker class="ml-4"></app-colorpicker>
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="56"
            viewBox="0 0 55 56"
          >
            <defs>
              <linearGradient
                id="gradientId"
                x1="70%"
                y1="0%"
                x2="30%"
                y2="100%"
              >
                <stop offset="30.19%" stop-color="#634000" />
                <stop offset="86.72%" stop-color="#D6B472" />
              </linearGradient>
            </defs>
            <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
            <path
              d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
              stroke="#3183C8"
              stroke-opacity="0.7"
              fill="url(#gradientId)"
            />
          </svg> -->
       
      </div>
    </div>
    <div class="rounded">
      <h1 class="sub-header">Font Color</h1>
      <p class="instructions">Select or Custom your Font Color</p>
      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
       <app-colorpicker class="ml-4"></app-colorpicker>
      </div>
    </div>
  </div>
</div>

<!-- Background & Stroke Color -->

<div class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[5px]">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 container">
    <div class="rounded">
      <h1 class="sub-header">Background Color</h1>
      <p class="instructions">Select or customize your Background color</p>
      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
        <app-colorpicker class="ml-4"></app-colorpicker>
      </div>
    </div>
    <div class="rounded">
      <h1 class="sub-header">Stroke Color</h1>
      <p class="instructions">Select or Custom your Font Color</p>
      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
        <app-colorpicker class="ml-4"></app-colorpicker>
      </div>
    </div>
  </div>
</div>

<!-- Sidebar Background & its Font & Icon Color -->

<div class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[5px]">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 container">
    <div class="rounded">
      <h1 class="sub-header">Sidebar Color</h1>
      <p class="instructions">Select or customize your sidebar color</p>
      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
        <app-colorpicker class="ml-4"></app-colorpicker>
        <!-- <input
          placeholder="#1A4971"
          class="sub-header !w-[135px] !h-[44px] border text-center ml-[18px]"
          value="#1A4971"
        />
        <div class="selector-icon !ml-[10px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="56"
            viewBox="0 0 55 56"
          >
            <defs>
              <linearGradient
                id="gradientId"
                x1="70%"
                y1="0%"
                x2="30%"
                y2="100%"
              >
                <stop offset="30.19%" stop-color="#634000" />
                <stop offset="86.72%" stop-color="#D6B472" />
              </linearGradient>
            </defs>
            <ellipse cx="27.5" cy="28" rx="27.5" ry="28" fill="#21252A" />
            <path
              d="M54.5 28C54.5 43.1964 42.4032 55.5 27.5 55.5C12.5968 55.5 0.5 43.1964 0.5 28C0.5 12.8036 12.5968 0.5 27.5 0.5C42.4032 0.5 54.5 12.8036 54.5 28Z"
              stroke="#3183C8"
              stroke-opacity="0.7"
              fill="url(#gradientId)"
            />
          </svg>
        </div> -->
      </div>
    </div>
    <div class="rounded">
      <h1 class="sub-header">Sidebar fonts & Icons Color</h1>
      <p class="instructions">Select or Customize your Fonts & Icons color</p>
      <div class="flex items-center">
        <h1 class="sub-header">Custom Color</h1>
        <app-colorpicker class="ml-4"></app-colorpicker>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[5px] !h-[110px]"
>
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">
    <div class="rounded flex items-center justify-between">
      <div>
        <h1 class="sub-header">Transparent Sidebar</h1>
        <p class="instructions !mt-[0px]">
          Make the desktop sidebar transparent
        </p>
      </div>
      <div>
        <form [formGroup]="formGroup">
          <mat-slide-toggle
            formControlName="enableTransparent"
          ></mat-slide-toggle>
          <!-- <button mat-raised-button type="submit">Save Settings</button> -->
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid p-[29px] bg-[#EFF8FF] !m-[3px] !ml-[5px] !mt-[5px] !mb-[62px]"
>
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">
    <div class="rounded">
      <h1 class="sub-header">Font Family</h1>
      <p class="instructions !mt-[0px]">Select or customize Font Family</p>
      <button type="button" class="custom-theme-button">
        Save as custom Theme
      </button>
    </div>
  </div>
</div>

<div class="container-fluid p-[29px] !mt-[5px] bg-[#EAEDEF]">
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">
    <div class="rounded flex justify-end">
      <button type="button" class="back-button !mr-[10px]">Back</button>
      <button type="button" class="save-button">Save</button>
    </div>
  </div>
</div>
